import { ref, computed } from 'vue';

export default function(props, currentIndex, emitChangeEvent) {
  //定义常量
  const DEFAULT_DURATION = 200; //默认期间
  const MIN_DISTANCE = 10; //最小距离
  const MOMENTUM_LIMIT_TIME = 30; //滑动时间限制
  const MOMENTUM_LIMIT_DISTANCE = 15; //滑动距离限制

  let duration = 0; //滑动动画期间
  let direction = 'vertical'; //滑动方向
  let offsetX = 0; //x轴偏移量
  let offsetY = 0; //y轴偏移量
  let startX = 0; //x轴起始位置
  let startY = 0; //y轴起始位置
  let moving = false; //是否滑动中
  let startOffset = 0; //开始偏移量
  let transitionEndTrigger = null; //滑动结束函数
  let touchStartTime = 0; //记录开始滑动时间
  let momentumOffset = 0; //记录开始滑动位置

  let offset = ref(0); //偏移量
  let itemPxHeight = ref(44); // 子元素高度
  //let visibleItemCount = ref(5); // 可视区域子元素个数
  let hoverIndex = ref(0); //滑动时处在选择区域上的索引

  //基础偏移量
  // let baseOffset = computed(() => {
  //   return (itemPxHeight.value * (visibleItemCount.value - 1)) / 2;
  // });
  let baseOffset =88;
  // 外层容器高度
  // let wrapHeight = computed(() => {
  //   return  itemPxHeight.value * visibleItemCount.value;
  // });
  //遮罩层样式
  // let maskStyle = computed(() => {
  //   return { backgroundSize: `100% ${(wrapHeight.value - itemPxHeight.value) / 2}px` };
  // });
  //选择区域样式
  // let frameStyle = computed(() => {
  //   return  { height: `${itemPxHeight.value}px` };
  // });
  // ul内层元素高度计算
  let wrapperStyle = computed(() => {
    return {
      transform: `translate3d(0, ${offset.value + baseOffset}px, 0)`,
      transitionDuration: `${duration}ms`,
      transitionProperty: duration ? 'all' : 'none',
    };
  });
  // li元素动态设置动画
  let liStyle = computed(() => {
    return function (index){
      let _ind = hoverIndex.value - index;
      let rotateX = !_ind ? 0 : _ind < 0 ? _ind * 10 - 15 : _ind * 10 + 15;
      let scale = 1 - Math.abs(_ind) / 10;
      return {
        fontWeight: rotateX ? '300' : '500',
        transform: `rotateX(${rotateX}deg) scale(${scale})`,
        transitionDuration: '50ms',
        transitionProperty: duration ? 'all' : 'none',
      };
    };
  });

  /**
   * 触摸开始
   */
  const onTouchStart = (event) => {
    //初始化变量
    direction = '';
    offsetX = 0;
    offsetY = 0;
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
    startOffset = offset.value;
    duration = 0;
    transitionEndTrigger = null;
    touchStartTime = Date.now();
    momentumOffset = startOffset;
  };
  /**
   * 滑动结束
   */
  const onTransitionEnd = () => {
    moving = false;
    duration = 0;
    if (transitionEndTrigger) {
      transitionEndTrigger();
      transitionEndTrigger = null;
    }
  };
  /**
   * 触摸移动
   */
  const onTouchMove = (event) => {
    const touch = event.touches[0];
    offsetX = Math.abs(touch.clientX - startX);
    offsetY = Math.abs(touch.clientY - startY);
    direction = direction || getDirection(offsetX, offsetY);
    if (direction === 'vertical') {
      moving = true;
      preventDefault(event, true);
    }
    //计算偏移量
    offset.value = range(startOffset + (touch.clientY - startY), -(props.initOptions.realOptions.length * itemPxHeight.value), itemPxHeight.value);
    const now = Date.now();
    if (now - touchStartTime > MOMENTUM_LIMIT_TIME) {
      touchStartTime = now;
      momentumOffset = offset.value;
    }
    //currentDic.value = touch.clientY - startY;
    hoverIndex.value = getIndexByOffset(props.initOptions.realOptions.length);
  };

  /**
   * 触摸结束
   */
  const onTouchEnd = () => {
    const distance = offset.value - momentumOffset;
    let dt = Date.now() - touchStartTime;
    const allowMomentum = dt < MOMENTUM_LIMIT_TIME && Math.abs(distance) > MOMENTUM_LIMIT_DISTANCE;
    if (allowMomentum) {
      momentum(distance, dt, props.initOptions.realOptions.length);
      return;
    }
    const index = getIndexByOffset(props.initOptions.realOptions.length);
    duration = DEFAULT_DURATION;
    setIndex(index, true);
  };

  // 获取当前展示的元素数据信息
  const setIndex = (index, emitChange) => {
    index = adjustIndex(index, props.initOptions.realOptions) || 0;
    hoverIndex.value = index;
    let oft = -index * itemPxHeight.value;
    const trigger = () => {
      if (index !== currentIndex.value) {
        currentIndex.value = index;
        if (emitChange) {
          emitChangeEvent(index)
        }
      }
    };
    // 滑动结束后触发事件
    if (moving && oft !== offset.value) {
      transitionEndTrigger = trigger;
    } else {
      trigger();
    }
    offset.value = oft;
  };

  // 滑动动画函数
  const momentum = (distance, dt, len) => {
    const speed = Math.abs(distance / dt);
    distance = offset.value + (speed / 0.003) * (distance < 0 ? -1 : 1);
    const index = getIndexByOffset(len);
    duration = speed;
    setIndex(index, true);
  };
  //调整滑动选项
  const adjustIndex = (index, options) => {
    index = range(index, 0, options.length);
    for (let i = index; i < options.length; i++) {
      if (!isOptionDisabled(options[i])) return i;
    }
    for (let i = index - 1; i >= 0; i--) {
      if (!isOptionDisabled(options[i])) return i;
    }
  };
  // 滑动偏移量
  const getIndexByOffset = (len) => {
    return range(Math.round(-offset.value / itemPxHeight.value), 0, len - 1);
  };
  //判断选项是否为不可选择
  const isOptionDisabled = (option) => {
    return option !== null && typeof option === 'object' && option.disabled;
  };
  // 滑动范围限制
  const range = (num, min, max) => {
    return Math.min(Math.max(num, min), max);
  };
  // 确定滑动方向
  const getDirection = (x, y) => {
    if (x > y && x > MIN_DISTANCE) {
      return 'horizontal';
    }
    if (y > x && y > MIN_DISTANCE) {
      return 'vertical';
    }
    return '';
  };
  // 阻止默认行为
  const preventDefault = (event, isStopPropagation) => {
    if (typeof event.cancelable !== 'boolean' || event.cancelable) {
      event.preventDefault();
    }
    if (isStopPropagation) {
      event.stopPropagation();
    }
  };

  return {
    setIndex,
    liStyle,
    //frameStyle,
    //maskStyle,
    wrapperStyle,
    onTouchStart,
    onTouchMove,
    onTransitionEnd,
    onTouchEnd,
  };
}